module.exports = __webpack_public_path__ + "img/ideation-04-keyfeature-ico-03-blue.0b4e4c5b.svg";